/* Actions */
export const SET_LANGUAGE = "setLanguage";

/* URLs */
export const LOGIN_AUTH2_URL = "https://zilumbbkac.execute-api.eu-west-1.amazonaws.com/auth/auth.s2/InvoxAPI";
export const REFRESH_URL = "https://zilumbbkac.execute-api.eu-west-1.amazonaws.com/auth/refresh/InvoxAPI"

export const LOGIN_AUTH1_URL =
  "https://apiv2.invoxcontact.com/auth/auth.s1/InvoxAPI";
export const GENERALI_LOGIN_AUTH1_URL =
  "https://apis.generali.invoxcontact.io/auth/auth.s1/InvoxAPI";

export const DOMAIN_TYPE = {
    numintec: 'Numintec',
    generali: 'Generali'
}

/* Constants */
export const X_API_KEY = "c0rn05wuqo8F8AspQ5mtD5NaPyJ8SIcQ8gUbhovV";
export const GENERALI_X_API_KEY = "NBYZjmSWHC6xx1z6taBGr8h47BOrxdeA1w86E2wX"

export const EXTRA_TOKEN = "extraToken";
export const REFRESH_TOKEN = "refreshToken";
export const ID_TOKEN = "idToken";
export const TOKEN_TYPE = "tokenType";
export const EXPIRE = "expire";
export const USER_INFO = "userInfo";
export const USERNAME = "username";
export const LANGUAGE = "language";